// contractsCol.tsx
import { statusLabel } from "../../../utils/media";
import { convertToSentenceCase, formatCurrency, formatDate, formatNumber } from "../../libs/utils";
import React from "react";

function getDaysBetween(start, end) {
  const startDate: any = new Date(start);
  const endDate: any = new Date(end);
  const msInDay: any = 1000 * 60 * 60 * 24;
  return Math.ceil((endDate - startDate) / msInDay);
}

export const contractsCol = (filterStatus: string) => [
  { id: 1, headerName: "Renewal Status", field: "renewalStatus", checked: true, hide: false },
  {
    id: 2,
    headerName: "Send On",
    field: "renewalInviteSendOn",
    checked: filterStatus === "ready_to_send",
    hide: filterStatus !== "ready_to_send",
  },
  { id: 3, headerName: "Property", field: "propertyDetails.propertyName", checked: true, hide: false },
  { id: 4, headerName: "Unit Code", field: "propertyDetails.unitCode", checked: true, hide: false },
  { id: 5, headerName: "Tenant", field: "tenantDetails.tenantNameEN", checked: true, hide: false },
  // { id: 6, headerName: "Annual Rent", field: "annualRent", checked: true, hide: false },
  { id: 7, headerName: "Start Date", field: "leaseTerms.leaseStartDate", checked: true, hide: false },
  { id: 8, headerName: "End Date", field: "leaseTerms.leaseEndDate", checked: true, hide: false },
  { id: 9, headerName: "Contract Type", field: "leaseType", checked: true, hide: false },
  { id: 10, headerName: "AWB No", field: "shipmentNumber", checked: true, hide: false },
  { id: 11, headerName: "Owner Name", field: "ownerName", checked: true, hide: false },
  { id: 12, headerName: "Property Admin", field: "adminManager.name", checked: true, hide: false },

  // extra hidden fields from leaseCol
  { id: 13, headerName: "Nationality", field: "tenantDetails.nationality", checked: false, hide: true },
  { id: 14, headerName: "Email", field: "tenantDetails.email", checked: false, hide: true },
  { id: 15, headerName: "Marital Status", field: "tenantDetails.maritalStatus", checked: false, hide: true },
  { id: 16, headerName: "Signatory Name", field: "signatoryName", checked: false, hide: true },
  { id: 17, headerName: "Signatory Designation", field: "signatoryDesignation", checked: false, hide: true },
  { id: 18, headerName: "Lease Nature", field: "leaseTerms.leaseNature", checked: false, hide: true },
  { id: 19, headerName: "Lease Executive", field: "leaseManager.name", checked: false, hide: true },
  { id: 20, headerName: "External Agent", field: "externalAgent", checked: false, hide: true },
  { id: 21, headerName: "Vacating Date", field: "vacatingDate", checked: false, hide: true },
  { id: 22, headerName: "Occupants", field: "tenantDetails.numberOfOcupants", checked: false, hide: true },
  { id: 23, headerName: "Rent Free Days", field: "leaseTerms.rentFreeDays", checked: false, hide: true },
  { id: 24, headerName: "Rent Free Start", field: "leaseTerms.rentFreeStartDate", checked: false, hide: true },
  { id: 25, headerName: "Rent Free End", field: "leaseTerms.rentFreeEndDate", checked: false, hide: true },
  { id: 26, headerName: "Move-in Date", field: "leaseTerms.moveInDate", checked: false, hide: true },
  { id: 27, headerName: "Ejari Contract No", field: "ejari.contractNumber", checked: false, hide: true },
  { id: 28, headerName: "Bedrooms", field: "propertyDetails.unitSubType", checked: false, hide: true },
  { id: 29, headerName: "Usage Type", field: "propertyDetails.usagesType", checked: false, hide: true },
  { id: 30, headerName: "Built-up Area", field: "propertyDetails.areaSqft", checked: false, hide: true },
  { id: 31, headerName: "Unit Type", field: "unitType", checked: false, hide: true },
  { id: 32, headerName: "Business Unit", field: "businessUnit", checked: false, hide: true },
  { id: 33, headerName: "Is AutoPay Active", field: "isAutoPayActive", checked: false, hide: true },

  { id: 34, headerName: "Unit Approved Rent", field: "unitApprovedRent", checked: true, hide: false },
  { id: 35, headerName: "Current Rent", field: "leaseTerms.contractAmount", checked: true, hide: false },
  { id: 36, headerName: "Renewal Rent", field: "leaseTerms.renewalRent", checked: true, hide: false },
  { id: 37, headerName: "Contract Rent", field: "bookingTerms.contractRent", checked: true, hide: false },
  { id: 38, headerName: "Change", field: "leaseTerms.change", checked: true, hide: false },
  { id: 39, headerName: "Payments", field: "leaseTerms.noOfCheques", checked: true, hide: false },
  { id: 40, headerName: "Declined Reason", field: "leaseStatusHistory", checked: true, hide: false },
  { id: 41, headerName: "DEWA", field: "propertyDetails.dewa", checked: false, hide: true },
  { id: 42, headerName: "Address Line 1", field: "propertyDetails.address.addressLine1", checked: false, hide: true },
  { id: 43, headerName: "Address Line 2", field: "propertyDetails.address.addressLine2", checked: false, hide: true },
  { id: 44, headerName: "Community", field: "propertyDetails.address.community", checked: false, hide: true },
  { id: 45, headerName: "Sub Community", field: "propertyDetails.address.subCommunity", checked: false, hide: true },
  { id: 46, headerName: "Security Deposit", field: "leaseTerms.securityDeposit", checked: false, hide: true },
  { id: 47, headerName: "No. Of Installments", field: "bookingTerms.numberOfInstallments", checked: false, hide: true },
  { id: 48, headerName: "Mobile", field: "tenantDetails.mobileNumber", checked: false, hide: true },
  {
    id: 49,
    headerName: "Direct Debit Enabled",
    field: "propertyDetails?.isDirectDebitEnable",
    checked: false,
    hide: true,
  },
  { id: 50, headerName: "Approved Rate", field: "approvedRate", checked: false, hide: true },
  { id: 150, headerName: "ID", field: "recordNumber", checked: false, hide: true },
  { id: 51, headerName: "Actions", field: "action", checked: true, hide: false },
];

export const contractsColumn = (contractsColumns, filterStatus, setRenewalStatus, MoreAction) => {
  return contractsColumns.map((col) => {
    if (col.field === "renewalStatus") {
      return { ...col, maxWidth: 200, cellRendererFramework: ({ data }) => setRenewalStatus(data) };
    } else if (col.field === "renewalInviteSendOn") {
      return {
        ...col,
        maxWidth: 150,
        hide: filterStatus !== "ready_to_send",
        cellRendererFramework: ({ data }) => formatDate(data?.renewalInviteSendOn),
      };
    } else if (col.field === "tenantDetails.tenantNameEN") {
      return { ...col, cellStyle: { textTransform: "capitalize" } };
    } else if (col.field === "annualRent") {
      return {
        ...col,
        type: "rightAligned",
        cellRendererFramework: ({ data }) =>
          formatCurrency(data.bookingTerms?.annualBaseRent || data.bookingTerms?.renewalAmount),
      };
    } else if (col.field === "leaseTerms.leaseStartDate") {
      return {
        ...col,
        minWidth: 150,
        maxWidth: 200,
        cellRendererFramework: ({ data }) => formatDate(data?.leaseTerms?.leaseStartDate),
      };
    } else if (col.field === "leaseTerms.leaseEndDate") {
      return {
        ...col,
        minWidth: 150,
        sort: "asc",
        cellRendererFramework: ({ data }) => formatDate(data?.leaseTerms?.leaseEndDate),
      };
    } else if (col.field === "leaseType") {
      return { ...col, cellRendererFramework: ({ data }) => statusLabel(data?.leaseType) };
    } else if (col.field === "leaseTerms.contractAmount") {
      return {
        ...col,
        maxWidth: 200,
        type: "rightAligned",
        cellRendererFramework: ({ data }) =>
          formatCurrency(data.bookingTerms?.annualBaseRent || data.leaseTerms?.contractAmount),
      };
    } else if (col.field === "leaseTerms.renewalRent") {
      return {
        ...col,
        maxWidth: 200,
        type: "rightAligned",
        cellRendererFramework: ({ data }) => formatCurrency(data?.bookingTerms?.renewalAmount),
      };
    } else if (col.field === "bookingTerms.contractRent") {
      return {
        ...col,
        maxWidth: 200,
        type: "rightAligned",
        cellRendererFramework: ({ data }) => formatCurrency(data?.bookingTerms?.contractRent),
      };
    } else if (col.field === "leaseTerms.change") {
      return {
        ...col,
        type: "rightAligned",
        cellRendererFramework: ({ data }) => {
          const { bookingTerms, leaseTerms } = data;
          const {
            renewalAmount,
            annualBaseRent,
            changeValue,
            amountType,
            amountChange: percentAmount,
          } = bookingTerms || {};
          const contractAmount = leaseTerms?.contractAmount;

          const calculateAmountToFormat = () =>
            changeValue !== "no_change" && renewalAmount ? renewalAmount - annualBaseRent || contractAmount : 0;

          const formatPercentage = () =>
            changeValue === "no_change" ? "0" : `${changeValue === "decrease" ? "-" : ""}${formatNumber(percentAmount)}%`;

          const amountToFormat = calculateAmountToFormat();
          const percentage = formatPercentage();

          return amountType === "percentage" ? percentage : formatCurrency(amountToFormat) || "0";
        },
      };
    } else if (col.field === "leaseStatusHistory") {
      return {
        ...col,
        hide: !(filterStatus === "renewal_declined" || filterStatus === "all"),
        cellRendererFramework: ({ data }) => {
          let statusData = [...(data?.leaseStatusHistory || [])];
          statusData.reverse();
          const dataResult = statusData?.find((item) => item?.status === "renewal_declined");
          return <div>{dataResult?.reason ? convertToSentenceCase(dataResult?.reason) : ""}</div>;
        },
      };
    } else if (col.field === "leaseTerms.rentFreeStartDate") {
      return {
        ...col,
        cellRendererFramework: ({ data }) => formatDate(data?.leaseTerms?.rentFreeStartDate),
      };
    } else if (col.field === "leaseTerms.rentFreeEndDate") {
      return {
        ...col,
        cellRendererFramework: ({ data }) => formatDate(data?.leaseTerms?.rentFreeEndDate),
      };
    } else if (col.field === "leaseTerms.moveInDate") {
      return {
        ...col,
        cellRendererFramework: ({ data }) => formatDate(data?.leaseTerms?.moveInDate),
      };
    } else if (col.field === "vacatingDate") {
      return {
        ...col,
        cellRendererFramework: ({ data }) => formatDate(data?.vacatingDate),
      };
    } else if (col.field === "leaseTerms.rentFreeDays") {
      return {
        ...col,
        cellRendererFramework: ({ data }) =>
          getDaysBetween(data?.leaseTerms?.rentFreeStartDate, data?.leaseTerms?.rentFreeEndDate),
      };
    } else if (col.field === "propertyDetails?.isDirectDebitEnable") {
      return {
        ...col,
        cellRendererFramework: ({ data }) => <span>{data?.propertyDetails?.isDirectDebitEnable ? "Yes" : "No"}</span>,
      };
    } else if (col.field === "action") {
      return {
        ...col,
        maxWidth: 200,
        pinned: "right",
        filter: false,
        cellRendererFramework: MoreAction,
      };
    }
    return col;
  });
};
